var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg916Empty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024.000000pt",
    height: "1024.000000pt",
    viewBox: "0 0 1024.000000 1024.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1024.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2230 5020 l0 -4370 2890 0 2890 0 0 4370 0 4370 -2890 0 -2890 0 0 -4370z m5368 3 l3 -3953 -2481 0 -2480 0 0 3948 c0 2172 3 3952 7 3955 3 4 1118 6 2477 5 l2471 -3 3 -3952z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg916Empty);
export default __webpack_public_path__ + "static/media/9_16_empty.3bc323cb6c2f9be4723e9b4ee3dbc154.svg";
export { ForwardRef as ReactComponent };